"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appleChannelApiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
const apple_product_page_browse_1 = require("./apple-product-page-browse");
const apple_search_results_1 = require("./apple-search-results");
const apple_search_tabs_1 = require("./apple-search-tabs");
const apple_today_tabs_1 = require("./apple-today-tabs");
function appleChannelGeneralApiClient(networkClient) {
    return {
        findApplicationOptions: async (params, query) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/options/applications`, query);
        },
        findProductPagesOptions: async (params) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/options/product-pages`);
        },
        findAppProductPagesOptions: async (params) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/apps/${params.applicationRef}/options/product-pages`);
        },
        getAppleStatus: async (params) => {
            return networkClient.getHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaigns/${params.campaignId}/apple/status`);
        },
        listInappropriateKeywords: async (query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/inappropriate-keywords`, query, config);
        },
        createInappropriateKeyword: async (body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/inappropriate-keywords`, body);
        },
        deleteInappropriateKeyword: async (params) => {
            return networkClient.deleteHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/inappropriate-keywords/${params.id}`);
        },
        listScheduledChannelChanges: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaign/${params.campaignId}/scheduled-changes`, query, config);
        },
        createScheduledChannelChanges: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaign/${params.campaignId}/scheduled-change`, body);
        },
        deleteScheduledChannelChanges: async (params) => {
            return networkClient.deleteHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaign/${params.campaignId}/scheduled-change/${params.scheduledChangeId}`);
        },
        updateScheduledChannelChanges: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaign/${params.campaignId}/scheduled-change/${params.scheduledChangeId}`, body);
        },
        listScheduledRegionChanges: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaign/${params.campaignId}/region/${params.regionId}/scheduled-changes`, query, config);
        },
        listScheduledRegionsChanges: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaign/${params.campaignId}/region/scheduled-changes`, query, config);
        },
        createScheduledRegionChanges: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaign/${params.campaignId}/region/${params.regionId}/scheduled-change`, body);
        },
        deleteScheduledRegionChanges: async (params) => {
            return networkClient.deleteHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaign/${params.campaignId}/region/${params.regionId}/scheduled-change/${params.scheduledChangeId}`);
        },
        updateScheduledRegionChanges: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaign/${params.campaignId}/region/${params.regionId}/scheduled-change/${params.scheduledChangeId}`, body);
        },
        updateScheduledKeywordAssignmentsChanges: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaign/${params.campaignId}/keyword-assignments/scheduled-change/${params.scheduledChangeId}`, body);
        },
        createScheduledKeywordAssignmentsChanges: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaign/${params.campaignId}/keyword-assignments/scheduled-change`, body);
        },
        listScheduledKeywordAssignmentsChanges: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaign/${params.campaignId}/keyword-assignments/scheduled-changes`, query, config);
        },
        deleteScheduledKeywordAssignmentsChanges: async (params) => {
            return networkClient.deleteHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaign/${params.campaignId}/keyword-assignments/scheduled-change/${params.scheduledChangeId}`);
        },
        updateScheduledKeywordChanges: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaign/${params.campaignId}/keyword/${params.keywordId}/scheduled-change/${params.scheduledChangeId}`, body);
        },
        createScheduledKeywordChanges: async (params, body) => {
            return networkClient.postHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaign/${params.campaignId}/keyword/${params.keywordId}/scheduled-change`, body);
        },
        listScheduledKeywordChanges: async (params, query, config) => {
            return networkClient.listHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaign/${params.campaignId}/keyword/scheduled-changes`, query, config);
        },
        deleteScheduledKeywordChanges: async (params) => {
            return networkClient.deleteHttp(data_lib_1.APPLE_CHANNELS_WEB_SERVICE, `/api/v2/apple-channels/teams/${params.teamId}/campaign/${params.campaignId}/keyword/scheduled-change/${params.scheduledChangeId}`);
        },
    };
}
function appleChannelApiClient(networkClient) {
    return {
        ...appleChannelGeneralApiClient(networkClient),
        ...(0, apple_search_results_1.appleChannelSearchResultsApiClient)(networkClient),
        ...(0, apple_search_tabs_1.appleChannelSearchTabsApiClient)(networkClient),
        ...(0, apple_today_tabs_1.appleChannelTodayTabApiClient)(networkClient),
        ...(0, apple_product_page_browse_1.appleChannelsProductPageBrowseClient)(networkClient),
    };
}
exports.appleChannelApiClient = appleChannelApiClient;
